import { render, staticRenderFns } from "./Integrations.vue?vue&type=template&id=afe04944&scoped=true&"
import script from "./Integrations.vue?vue&type=script&lang=js&"
export * from "./Integrations.vue?vue&type=script&lang=js&"
import style0 from "./Integrations.vue?vue&type=style&index=0&id=afe04944&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afe04944",
  null
  
)

export default component.exports